import { Button, Card, Flex, Form, message, Space } from 'antd'
import dayjs from 'dayjs'
import { BoosterProgramDetail, BoosterProgramFormValues } from 'Modules'
import { useState } from 'react'

import { ProgramSettings } from '../form-create/program-settings'
import { isFormValidateError } from '../form-create/utils'

interface Props {
  data: BoosterProgramDetail
  onCancel: () => void
  onSave: (values: BoosterProgramFormValues) => Promise<void> | void
}

const toFormValues = (d: BoosterProgramDetail): BoosterProgramFormValues => ({
  title: d.title,
  period: [dayjs(d.period.start), dayjs(d.period.end)],
  description: d.description,
  terms: d.terms,
  enrollmentPeriodValue: d.enrollmentPeriodValue,
  enrollmentPeriodUnit: d.enrollmentPeriodUnit,
  targetUsers: d.targetUsers,
  whitelistFileName: d.whitelistFileName,
  participantLimitType: d.participantLimitType,
  participantLimit: d.participantLimit,
  startingFillNumber: d.startingFillNumber,
  increaseByPercent: d.increaseByPercent,
  increaseEvery: d.increaseEvery,
  increaseEveryUnit: d.increaseEveryUnit,
  milestones: [],
})

export const ProgramSettingsEditForm = ({ data, onCancel, onSave }: Props) => {
  const [form] = Form.useForm<BoosterProgramFormValues>()
  const [saving, setSaving] = useState(false)

  const handleSave = async () => {
    try {
      const values = await form.validateFields()
      // whitelistFile isn't a registered field, so it's absent from validateFields' result.
      const whitelistFile = form.getFieldValue('whitelistFile') as File | undefined
      setSaving(true)
      await onSave({ ...values, whitelistFile })
    } catch (err) {
      if (isFormValidateError(err)) return
      message.error('Failed to save program settings')
    } finally {
      setSaving(false)
    }
  }

  return (
    <Card className="booster-detail__settings-card">
      <Form
        form={form}
        layout="vertical"
        variant="filled"
        className="booster-program-create"
        initialValues={toFormValues(data)}
      >
        <ProgramSettings />

        <Flex justify="flex-end" gap={8} className="booster-detail__edit-actions">
          <Space>
            <Button onClick={onCancel} disabled={saving}>
              Cancel
            </Button>
            <Button
              type="primary"
              className="booster-program-create__primary-btn"
              loading={saving}
              onClick={handleSave}
            >
              Save
            </Button>
          </Space>
        </Flex>
      </Form>
    </Card>
  )
}
